import { InvertedLoadingIndicator } from 'client/shared/Spinner';
import React from 'react';
import styles from './styles.sass';

export default function RedirectingInterstitial() {
  return (
    <div className="isV2LegacyPage">
      <InvertedLoadingIndicator height={200} />
      <h3 className={styles.redirectingLabel}>Redirecting…</h3>
    </div>
  );
}
